import { DependsOnIfEnum } from "@generation/schema-core/src/client/enums/dependsOnIfEnum";
import { DependsOnThenEnum } from "@generation/schema-core/src/client/enums/dependsOnThenEnum";
import { INestedDependsOn } from "@generation/schema-core/src/client/model/dependsOn";
import { RegelingOptions } from "@klantondersteuning/shared/src/form/interface/SimpleForm/RegelingOptions";
import { regelingProp } from "../utils/contactFormulierProps";
import { hideWhenVoorWieSteltUEenVraagIsShownAndEmptyOrNotVraagVoorMezelfEnIkBenKlant } from "./showVoorWieSteltUEenVraag";

export const showBsnInput: INestedDependsOn[] = [
  {
    conditions: [
      {
        property: regelingProp,
        if: DependsOnIfEnum.IsEqualToValue,
        value: RegelingOptions.MedicijnenMeeOpReis
      }
    ],
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  },
  {
    conditions: [
      {
        property: regelingProp,
        if: DependsOnIfEnum.IsEqualToValue,
        value: RegelingOptions.Buitenland
      }
    ],
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  },
  ...hideWhenVoorWieSteltUEenVraagIsShownAndEmptyOrNotVraagVoorMezelfEnIkBenKlant
];
